import React, { useState } from "react";

import { Plus } from "icons";

import { Button, Typography } from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";
import FilterHeader from "components/Common/FilterHeader";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import { useUserState } from "contexts/user";
import { useColumnHeaderSelector } from "hooks/useColumnHeaderSelector";
import { getPermissions } from "utils/roleBasedAccess";

import AssociatePeople from "./AssociatePeople";
import PeopleTable from "./Table";

import { PEOPLE_COLUMNS, PEOPLE_DATA } from "../../constants/peopleExplore";
import BusinessGlossarySummaryCard from "../BusinessGlossarySummaryCard";
import DeletePeople from "../DeleteAlert";

const People = ({ features, businessGlossary }) => {
  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isAssociatePeopleOpen, setIsAssociatePeopleOpen] = useState(false);
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);

  const columnHeaderSelector = useColumnHeaderSelector(PEOPLE_COLUMNS());
  return (
    <>
      <ExploreContainer>
        <div className="flex justify-between">
          <Typography style="h3" type="semibold">
            People using {businessGlossary?.name} (5)
          </Typography>
          <Typography style="h3" type="semibold">
            Summary
          </Typography>
          <PermissibleWrapper
            currentPermissions={userPermissions}
            acceptablePermissions="associate"
          >
            <Button
              label="Associate People"
              icon={Plus}
              onClick={() => setIsAssociatePeopleOpen(true)}
              data-cy="associate-people-button"
            />
          </PermissibleWrapper>
        </div>
        <BusinessGlossarySummaryCard businessGlossary={businessGlossary} />
        <FilterHeader
          entity="People"
          filterParams={{ setSearch: () => {} }}
          columnHeaderSelector={columnHeaderSelector}
          checkedRows={checkedRows}
          userPermissions={userPermissions}
          count={5}
          setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        />
        <PeopleTable
          peopleColumnData={PEOPLE_DATA}
          userPermissions={userPermissions}
          columns={columnHeaderSelector.columns}
          setCheckedRows={setCheckedRows}
          checkedRows={checkedRows}
          setIsAssociatePeopleOpen={setIsAssociatePeopleOpen}
        />
      </ExploreContainer>
      <DeletePeople
        entityName="People"
        isDeleteAlertOpen={isDeleteAlertOpen}
        setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
      />
      <AssociatePeople
        isPaneOpen={isAssociatePeopleOpen}
        setIsPaneOpen={setIsAssociatePeopleOpen}
        businessGlossary={businessGlossary}
      />
    </>
  );
};

export default People;
